"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var propserver_1 = require("propserver");
var NativeScrollable = /** @class */ (function (_super) {
    tslib_1.__extends(NativeScrollable, _super);
    function NativeScrollable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setStickyScroll = function () {
            utils_1.caf(_this.rafId);
            _this.rafId = utils_1.raf(function () {
                if (_this.willUnmount) {
                    return;
                }
                var rect = _this.scrollable.getBoundingClientRect();
                var windowHeight = window.innerHeight;
                var virtualParentOffsetHeight = _this.virtual.parentElement.offsetHeight;
                if (rect.top + _this.props.stickyXOffset < windowHeight && rect.top + rect.height - virtualParentOffsetHeight > windowHeight) {
                    _this.virtual.parentElement.style.transform = "translateY(-" + Math.abs(windowHeight - (rect.top + rect.height) - _this.props.stickyXOffset - virtualParentOffsetHeight) + "px)";
                    !_this.state.showStickyScroll && _this.setState({ showStickyScroll: true });
                }
                else {
                    _this.state.showStickyScroll && _this.setState({ showStickyScroll: false });
                }
            });
        };
        _this.onScrollWidthChanged = function (scrollWidth) {
            _this.virtual.style.width = scrollWidth + "px";
        };
        _this.scrollTo = function (x, y) {
            !isNaN(x) && (_this.scrollable.scrollLeft = x);
            !isNaN(y) && (_this.scrollable.scrollTop = y);
        };
        _this.setRef = function (el) {
            _this.scrollable = el;
        };
        _this.setVirtualContentRef = function (el) {
            _this.virtual = el;
        };
        _this.onScroll = function (e) {
            var original = e.target;
            var target = original === _this.scrollable ? _this.virtual.parentElement : _this.scrollable;
            if (original.scrollLeft === target.scrollLeft && original.scrollTop === target.scrollTop) {
                return;
            }
            target.scrollTo(original.scrollLeft, original.scrollTop);
        };
        _this.scrollable = null;
        _this.virtual = null;
        _this.scrollWidthObserver = null;
        _this.rafId = null;
        _this.willUnmount = false;
        _this.state = { showStickyScroll: true };
        return _this;
    }
    NativeScrollable.prototype.componentDidMount = function () {
        var stickyOverflowScrollX = this.props.stickyOverflowScrollX;
        if (stickyOverflowScrollX) {
            this.scrollWidthObserver = propserver_1.createObserver(this.scrollable, "scrollWidth", this.onScrollWidthChanged);
            this.scrollWidthObserver.observe();
            this.onScrollWidthChanged(this.scrollable.scrollWidth);
            this.setStickyScroll();
            window.addEventListener("scroll", this.setStickyScroll, { passive: true });
            window.addEventListener("resize", this.setStickyScroll, { passive: true });
        }
    };
    NativeScrollable.prototype.componentWillUnmount = function () {
        this.willUnmount = true;
        this.scrollWidthObserver && this.scrollWidthObserver.disconnect();
        window.removeEventListener("scroll", this.setStickyScroll);
        window.removeEventListener("resize", this.setStickyScroll);
    };
    NativeScrollable.prototype.getChildContext = function () {
        return {
            scrollTo: this.scrollTo
        };
    };
    NativeScrollable.prototype.getElement = function () {
        return this.scrollable;
    };
    NativeScrollable.prototype.renderStickyScrollbar = function () {
        var _a;
        var _b = this.props, theme = _b.theme, scrollSize = _b.scrollSize, width = _b.width, height = _b.height, bold = _b.bold;
        var showStickyScroll = this.state.showStickyScroll;
        var classes = classnames_1.default(theme["sticky-x"], theme["size_" + scrollSize], (_a = {},
            _a[theme["hide-sticky-scroll"]] = !showStickyScroll,
            _a[theme.bold] = bold,
            _a));
        var styles = {
            width: isNaN(width) ? width : utils_1.toREMString(width)
        };
        return (React.createElement("div", { className: classes, style: styles, onScroll: this.onScroll },
            React.createElement("div", { ref: this.setVirtualContentRef })));
    };
    NativeScrollable.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, stickyOverflowScrollX = _b.stickyOverflowScrollX, width = _b.width, height = _b.height, scrollSize = _b.scrollSize, style = _b.style, bold = _b.bold, children = _b.children, suppressX = _b.suppressX, suppressY = _b.suppressY, stickyXOffset = _b.stickyXOffset, others = tslib_1.__rest(_b, ["theme", "className", "stickyOverflowScrollX", "width", "height", "scrollSize", "style", "bold", "children", "suppressX", "suppressY", "stickyXOffset"]);
        var styles = tslib_1.__assign({}, style, { width: isNaN(width) ? width : utils_1.toREMString(width), height: isNaN(height) ? height : utils_1.toREMString(height), overflowX: suppressX ? "hidden" : "auto", overflowY: suppressY ? "hidden" : "auto" });
        var classes = classnames_1.default(theme.scroll, className, theme["size_" + scrollSize], (_a = {},
            _a[theme.bold] = bold,
            _a));
        var events = {};
        var stickyScrollBar = null;
        if (stickyOverflowScrollX) {
            events.onScroll = this.onScroll;
            stickyScrollBar = this.renderStickyScrollbar();
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", tslib_1.__assign({}, others, { style: styles, className: classes, ref: this.setRef }, events), children),
            stickyScrollBar));
    };
    NativeScrollable.defaultProps = {
        scrollSize: 4,
        stickyXOffset: 0
    };
    NativeScrollable.childContextTypes = {
        scrollTo: PropTypes.func
    };
    return NativeScrollable;
}(React.Component));
exports.default = NativeScrollable;
